export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7843.2344ae77.jpg";